import { PageHeader } from "@/components/shared/PageHeader";
import { useData } from "@/context/DataContext";
import { Reveal } from "@/components/shared/Reveal";
import { NewsCard } from "@/components/cards/NewsCard";

const IMG = "https://static.prod-images.emergentagent.com/jobs/19db1358-9c8e-4718-a041-5f96f8d9cb74/images/2f8dce2acb72e661e3147e3f9a951b1add6e5b452900a0ffdb30851011acd195.jpeg";

export default function Nyheter() {
  const { data } = useData();
  const news = data.news || [];
  return (
    <>
      <PageHeader kicker="Aktuellt" title="Nyheter" subtitle="All löpande information inför Novemberkåsan 2026." image={IMG} />
      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          {news.length ? (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {news.map((item, i) => (
                <Reveal key={item.id} delay={i * 0.06}><NewsCard item={item} /></Reveal>
              ))}
            </div>
          ) : (
            <p className="text-white/50 font-mono text-sm">Inga nyheter publicerade ännu.</p>
          )}
        </div>
      </section>
    </>
  );
}
